{
	"title": "Prohlášení",
	"table": {
		"material": "Materiál",
		"dateOfIssue": "Datum vydání",
		"quantity": "Množství",
		"carbonSavings": "Redukce uhlíku",
		"status": {
			"title": "Stav",
			"TransactionProcessing": "Zpracování transakcí",
			"CreatingDeclaration": "Vytvoření prohlášení",
			"GenerationFailed": "Generování se nezdařilo",
			"ReadyToDownload": "Připraveno ke stažení"
		}
	},
	"declarationLanguageSelect": {
		"title": "Jazyk deklarace",
		"description": "Vyberte jazyk deklarace.",
		"label": "Jazyk deklarace",
		"buttonBack": "Zpět",
		"buttonSave": "Uložit"
	},
	"downloadAllLanguageSelect": {
		"title": "Deklarační jazyky",
		"descriptionGlobal": "Vyberte jazyk pro všechna prohlášení.",
		"descriptionIndividual": "Nebo nastavte jazyk pro každou deklaraci samostatně.",
		"label": "Deklarační jazyky",
		"tableHeaderDeclaration": "Prohlášení (materiál/datum vydání)",
		"tableHeaderLanguage": "Jazyk deklarace",
		"buttonBack": "Zpět",
		"buttonDownload": "Stáhněte si prohlášení"
	},
	"declarationActions": {
		"changeLanguage": "Změnit jazyk deklarace",
		"preview": "Náhled",
		"download": "Stáhnout",
		"transaction": "Transakce",
		"showMoreTransactions": "Zobrazit více transakcí",
		"languageLabel": "Jazyk deklarace",
		"downloadAll": "Stáhněte si všechna prohlášení"
	}
}
